import { Button, Card, Col, Row, Table, Tag, Space, Select, Modal, Divider } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  ArrowRightOutlined,
  ArrowUpOutlined,
  BarChartOutlined,
  FileDoneOutlined,
  FileExclamationOutlined,
  FlagOutlined,
  MailOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { PHISHING_DASHBOARD, LIST_CAMPAIGN } from "../apis/apis";
import CulsightPageLoader from "../components/CulsightPageLoader";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip as RechartsTooltip,
  ResponsiveContainer,
} from "recharts";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Legend, LabelList } from "recharts";

import { DatePicker } from "antd";
import DashboardChart from "../components/DashboardChart";



function Dashboard() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [table_data, set_table_data] = useState(false);
  const [email_send, set_email_send] = useState("");
  const [email_open, set_email_open] = useState("");
  const [email_clicked, set_email_clicked] = useState("");
  const [data_submit, set_data_submit] = useState("");
  const [email_resend, set_email_resend] = useState("");
  const [Email_Sended_Chart, set_Email_Sended_Chart] = useState("");
  const [Email_Open_Chart, set_Email_Open_Chart] = useState("");
  const [Email_Clicked_Chart, set_Email_Clicked_Chart] = useState("");
  const [Data_Submit_Chart, set_Data_Submit_Chart] = useState("");
  const [Resend_Chart, set_Resend_Chart] = useState("");
  const [total_cam, set_total_cam] = useState(0);
  const [hover_show, set_hover_show] = useState(true);
  const [email_send_percent, set_email_send_percent] = useState(0);
  const [activeChart, setActiveChart] = useState(null);


  const [open_rate, set_open_rate] = useState(0);
  const [click_rate, set_click_rate] = useState(0);
  const [submit_rate, set_submit_rate] = useState(0);
  const [report_spam_rate, set_report_spam_rate] = useState(0);
  const [report_rate, set_report_rate] = useState(0);
  const [report_count, set_report_count] = useState(0);
const [Report_Chart, set_Report_Chart] = useState([]);




  const adjustZeroValue = (value) => {
    const parsed = parseInt(value);
    return parsed === 0 ? 0.0001 : parsed;
  };

  const CAMPAIGN_TRACKING_API = async (range = "weekly") => {
    const formData = new FormData();

    formData.append("range", range);

    const API_CALL = await PHISHING_DASHBOARD(formData);
    if (API_CALL?.data?.status) {
      console.log("email_send", API_CALL?.data?.email_send);
      set_email_send_percent(API_CALL?.data?.email_send_percent || 0);
      set_email_send(API_CALL?.data?.email_send);
      set_email_open(API_CALL?.data?.email_open);
      set_email_clicked(API_CALL?.data?.email_clicked);
      set_data_submit(API_CALL?.data?.data_submit);
      set_email_resend(API_CALL?.data?.email_resend);
      set_total_cam(API_CALL?.data?.total_user);
      set_open_rate(API_CALL?.data?.open_rate);
      set_click_rate(API_CALL?.data?.click_rate);
      set_submit_rate(API_CALL?.data?.submit_rate);
      set_report_spam_rate(API_CALL?.data?.report_spam_rate);
      set_report_rate(API_CALL?.data?.report_rate || 0);
set_report_count(API_CALL?.data?.email_report || 0);
      if (
        adjustZeroValue(
          parseInt(API_CALL?.data?.total_user) -
          parseInt(API_CALL?.data?.email_send),
        ) === 0.0001
      ) {
        set_hover_show(false);
      }
      set_Email_Sended_Chart([
        {
          name: "Remain",
          value: adjustZeroValue(
            parseInt(API_CALL?.data?.total_user) -
            parseInt(API_CALL?.data?.email_send),
          ),
        },
        { name: "Email Sended", value: parseInt(API_CALL?.data?.email_send) },
      ]);
      set_Email_Open_Chart([
        {
          name: "Remain",
          value: adjustZeroValue(
            parseInt(API_CALL?.data?.total_user) -
            parseInt(API_CALL?.data?.email_open),
          ),
        },
        { name: "Email Opened", value: parseInt(API_CALL?.data?.email_open) },
      ]);
      set_Email_Clicked_Chart([
        {
          name: "Remain",
          value: adjustZeroValue(
            parseInt(API_CALL?.data?.total_user) -
            parseInt(API_CALL?.data?.email_clicked),
          ),
        },
        {
          name: "Email Clicked",
          value: parseInt(API_CALL?.data?.email_clicked),
        },
      ]);
      set_Data_Submit_Chart([
        {
          name: "Remain",
          value: adjustZeroValue(
            parseInt(API_CALL?.data?.total_user) -
            parseInt(API_CALL?.data?.data_submit),
          ),
        },
        { name: "Data Submit", value: parseInt(API_CALL?.data?.data_submit) },
      ]);

    set_Report_Chart([
  {
    name: "Remain",
    value: adjustZeroValue(
      parseInt(API_CALL?.data?.total_user) -
      parseInt(API_CALL?.data?.email_report || 0)
    ),
  },
  {
    name: "Reported",
    value: parseInt(API_CALL?.data?.email_report || 0),
  },
]);
      set_Resend_Chart([
        {
          name: "Remain",
          value: adjustZeroValue(
            parseInt(API_CALL?.data?.total_user) -
            parseInt(API_CALL?.data?.email_resend),
          ),
        },
        { name: "Email Resend", value: parseInt(API_CALL?.data?.email_resend) },
      ]);
      setLoader(false);
    } else {
      console.log("error");
      setLoader(false);
    }
  };

  // LIST API
  useEffect(() => {
    const LIST_API = async () => {
      const FORM_DATA = new FormData();
      const API_CALL = await LIST_CAMPAIGN(FORM_DATA);
      if (API_CALL?.data?.status) {
        set_table_data(API_CALL?.data?.data);
        CAMPAIGN_TRACKING_API("weekly");
        setLoader(false);
      } else {
        console.log("error");
        setLoader(false);
      }
    };

    LIST_API();
  }, []);

  // TABLE COLUMNS
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => <span>{record.name}</span>,
    },
    {
      title: "SMTP",
      render: (text, record) => <span>{record.smtp_name}</span>,
    },
    {
      title: "User Group",
      render: (text, record) => (
        <span>
          {record.group_name} (
          {record.group_type === 1 ? "LMS Group" : "Local Group"})
        </span>
      ),
    },
    {
      title: "Email Template",
      dataIndex: "email_template",
      render: (text, record) => <span>{record.email_template_name}</span>,
    },
    /*{
  title: "User Count",
  dataIndex: "user_count",
  render: (text, record) => <span>{record.total_users}</span>,
},*/
   {
     title: "Stats",
     dataIndex: "stats",
     render: (_, record) => (
       <Space size="small">
         <Tag color="purple"
          style={{
    borderRadius: "12px",
    padding: "2px 10px",
  }}
         >
           Sent: {record.email_send || 0}
         </Tag>
   
         <Tag color="cyan"
          style={{
    borderRadius: "12px",
    padding: "2px 10px",
  }}
         >
           Open: {record.email_open || 0}
         </Tag>
   
         <Tag color="orange"
          style={{
    borderRadius: "12px",
    padding: "2px 10px",
  }}
         >
           Click: {record.email_clicked || 0}
         </Tag>
       </Space>
     ),
   },

    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          type="primary"
          size="small"
          onClick={() =>
            navigate("/view-campaign/" + btoa(record.id), {
              state: {
                from: "/",
              },
            })
          }
        >
          <BarChartOutlined />
        </Button>
      ),
      btoa,
    },
  ];
  //Dummy Data because trend API is not ready yet
  //const [trendData, setTrendData] = useState([]);



  return (
    <div className="lms-body">
      <Row>
        <Col span={12}>
          <h1>Overview</h1>
          <span style={{ fontSize: "15px", color: "gray", fontWeight: "600" }}>
            Monitor your phishing simulation performance
          </span>
        </Col>
        <Col span={12}>
          <span
            style={{
              float: "right",
              display: "flex",
              alignItems: "center",
              gap: "10px",
              fontSize: "15px",
              color: "gray",
              fontWeight: "600",
            }}
          >
            Total Users Tracking: <b style={{ color: "black" }}>{total_cam}</b>
            {/* Refresh Icon */}
            <Button onClick={() => window.location.reload()}>
              <ReloadOutlined style={{ cursor: "pointer", fontSize: "px" }} />
              Refresh
            </Button>
          </span>
        </Col>
      </Row>

      <Row gutter={16} style={{ marginTop: "20px" }}>
        <Col span={24}>
          <Card>
            {loader ? (
              <>Loading...</>
            ) : (
              <Row gutter={[24, 24]} justify="space-between">
                {/* Email Sent */}
                <Col xs={24} sm={12} md={8} lg={4} style={{ padding: "10px" }}>
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      height: 200,
                    }}
                  >
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart>
                       <Pie
  data={Email_Sended_Chart}
  cx="50%"
  cy="50%"
  innerRadius={55}
  outerRadius={80}
  dataKey="value"
  onMouseEnter={() => setActiveChart("sent")}
  onMouseLeave={() => setActiveChart(null)}
>
                          <Cell fill="#f4f4f4" />
                          <Cell fill="#8c3add" />
                        </Pie>

                        {hover_show && <RechartsTooltip />}
                      </PieChart>
                    </ResponsiveContainer>

                    {activeChart !== "sent" && (
  <div
    style={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      fontSize: "22px",
      fontWeight: "bold",
      color: "#8c3add",
    }}
  >
    {email_send_percent}%
  </div>
)}
                  </div>
                  <h3 style={{ textAlign: "center", color: "#8c3add" }}>
                    Email Sent ({email_send})
                  </h3>
                </Col>

                {/* Email Open */}
                <Col xs={24} sm={12} md={8} lg={4}>
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      height: 200,
                    }}
                  >
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart>
                        <Pie
                          data={Email_Open_Chart}
                          cx="50%"
                          cy="50%"
                          innerRadius={55}
                          outerRadius={80}
                          dataKey="value"
                          onMouseEnter={() => setActiveChart("open")}
onMouseLeave={() => setActiveChart(null)}
                        >
                          <Cell fill="#f4f4f4" />
                          <Cell fill="#1fa7a1" />
                        </Pie>
                        {hover_show && <RechartsTooltip />}
                      </PieChart>
                    </ResponsiveContainer>

                   {activeChart !== "open" && (
  <div
    style={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      fontSize: "22px",
      fontWeight: "bold",
      color: "#1fa7a1",
    }}
  >
    {open_rate}%
  </div>
)}
                  </div>

                  <h3 style={{ textAlign: "center", color: "#1fa7a1" }}>
                    Email Opened ({email_open})
                  </h3>
                </Col>
                {/* Clicked */}
                <Col xs={24} sm={12} md={8} lg={4}>
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      height: 200,
                    }}
                  >
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart>
                        <Pie
                          data={Email_Clicked_Chart}
                          cx="50%"
                          cy="50%"
                          innerRadius={55}
                          outerRadius={80}
                          dataKey="value"
                          onMouseEnter={() => setActiveChart("click")}
onMouseLeave={() => setActiveChart(null)}
                        >
                          <Cell fill="#f4f4f4" />
                          <Cell fill="#eab451" />
                        </Pie>
                        {hover_show && <RechartsTooltip />}
                      </PieChart>
                    </ResponsiveContainer>

                {activeChart !== "click" && (
  <div
    style={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      fontSize: "22px",
      fontWeight: "bold",
      color: "#eab451",
    }}
  >
    {click_rate}%
  </div>
)}
                  </div>

                  <h3 style={{ textAlign: "center", color: "#eab451" }}>
                    Clicked Link ({email_clicked})
                  </h3>
                </Col>

                {/* Submitted */}
                <Col xs={24} sm={12} md={8} lg={4}>
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      height: 200,
                    }}
                  >
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart>
                        <Pie
                          data={Data_Submit_Chart}
                          cx="50%"
                          cy="50%"
                          innerRadius={55}
                          outerRadius={80}
                          dataKey="value"
                           onMouseEnter={() => setActiveChart("submit")}
onMouseLeave={() => setActiveChart(null)}
                        >
                          <Cell fill="#f4f4f4" />
                          <Cell fill="#b37feb" />
                        </Pie>
                        {hover_show && <RechartsTooltip />}
                      </PieChart>
                    </ResponsiveContainer>

                   {activeChart !== "submit" && (
  <div
    style={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      fontSize: "22px",
      fontWeight: "bold",
      color: "#b37feb",
    }}
  >
    {submit_rate}%
  </div>
)}
                  </div>

                  <h3 style={{ textAlign: "center", color: "#b37feb" }}>
                    Submitted Data ({data_submit})
                  </h3>
                </Col>

                {/* Report Rate */}
<Col xs={24} sm={12} md={8} lg={4}>
  <div
    style={{
      position: "relative",
      width: "100%",
      height: 200,
    }}
  >
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          data={Report_Chart}
          cx="50%"
          cy="50%"
          innerRadius={55}
          outerRadius={80}
          dataKey="value"
          onMouseEnter={() => setActiveChart("report")}
onMouseLeave={() => setActiveChart(null)}
         
        >
          <Cell fill="#f4f4f4" />
          <Cell fill="#5B8DEF" />
        </Pie>
        {hover_show && <RechartsTooltip />}
      </PieChart>
    </ResponsiveContainer>

  {activeChart !== "report" && (
  <div
    style={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      fontSize: "22px",
      fontWeight: "bold",
      color: "#5B8DEF",
    }}
  >
    {report_rate}%
  </div>
)}

  </div>

  <h3 style={{ textAlign: "center", color: "#5B8DEF" }}>
  Reported Emails ({report_count})
  </h3>
</Col>

                {/* Spam */}
                <Col xs={24} sm={12} md={8} lg={4}>
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      height: 200,
                    }}
                  >
                    <ResponsiveContainer width="100%" height="100%">
                      <PieChart>
                        <Pie
                          data={Resend_Chart}
                          cx="50%"
                          cy="50%"
                          innerRadius={55}
                          outerRadius={80}
                          dataKey="value"
                         onMouseEnter={() => setActiveChart("spam")}
onMouseLeave={() => setActiveChart(null)}
                        >
                          <Cell fill="#f4f4f4" />
                          <Cell fill="#f97d7d" />
                        </Pie>
                        {hover_show && <RechartsTooltip />}
                      </PieChart>
                    </ResponsiveContainer>

                  {activeChart !== "spam" && (
  <div
    style={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      fontSize: "22px",
      fontWeight: "bold",
      color: "#f97d7d",
    }}
  >
    {report_spam_rate}%
  </div>
)}
                  </div>

                  <h3 style={{ textAlign: "center", color: "#f97d7d" }}>
                    Spam Emails ({email_resend})
                  </h3>
                </Col>
              </Row>
            )}
          </Card>
        </Col>
      </Row>

      <>
        <Row style={{ marginTop: "20px" }}>
          <Col span={24}>
            <DashboardChart />
          </Col>
        </Row>

      </>


      <Row gutter={[24, 24]} style={{ marginTop: "20px" }}>
        {/* Open Rate */}
        <Col flex="1">
          <Card
            bordered={false}
            style={{
              width: "100%",
              borderRadius: 16,
              height: 100,
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ marginTop: "-10px" }}>
              <h3 style={{ color: "#6b7280", margin: 0 }}>Open Rate</h3>
              <h1
                style={{
                  color: "#14b8a6",
                  fontSize: "28px",
                  fontWeight: "bold",
                }}
              >
                {open_rate}%
              </h1>
            </div>

            <Tag
              style={{
                background: "#d1fae5",
                border: "none",
                borderRadius: 12,
                padding: "10px",
                display: "flex",
                marginLeft: "auto",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <MailOutlined style={{ color: "#14b8a6", fontSize: 18 }} />
            </Tag>
          </Card>
        </Col>

        {/* Click Rate */}
        <Col flex="1">
          <Card
            bordered={false}
            style={{
              width: "100%",
              borderRadius: 16,
              height: 100,
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ marginTop: "-10px" }}>
              <h3 style={{ color: "#6b7280", margin: 0 }}>Click Rate</h3>
              <h1
                style={{
                  color: "#eab451",
                  fontSize: "28px",
                  fontWeight: "bold",
                }}
              >
                {click_rate}%
              </h1>
            </div>

            <Tag
              style={{
                background: "#f9d8af",
                border: "none",
                borderRadius: 12,
                padding: "10px",
                marginLeft: "auto",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ArrowUpOutlined style={{ color: "#eab451", fontSize: 18 }} />
            </Tag>
          </Card>
        </Col>

        {/* Submit Rate */}
        <Col flex="1">
          <Card
            bordered={false}
            style={{
              width: "100%",
              borderRadius: 16,
              height: 100,
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ marginTop: "-10px" }}>
              <h3 style={{ color: "#6b7280", margin: 0 }}>Submit Rate</h3>
              <h1
                style={{
                  color: "#b37feb",
                  fontSize: "28px",
                  fontWeight: "bold",
                }}
              >
                {submit_rate}%
              </h1>
            </div>

            <Tag
              style={{
                background: "#c296f25f",
                border: "none",
                borderRadius: 12,
                padding: "10px",
                marginLeft: "auto",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
             <FileDoneOutlined 
                style={{ color: "#b37feb", fontSize: 18 }}
              />
            </Tag>
          </Card>
        </Col>

 {/* Report Rate */}
      <Col flex="1">
          <Card
            bordered={false}
            style={{
              width: "100%",
              borderRadius: 16,
              height: 100,
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ marginTop: "-10px" }}>
              <h3 style={{ color: "#6b7280", margin: 0 }}>Report Rate</h3>
              <h1
                style={{
                  color: "#5B8DEF",
                  fontSize: "28px",
                  fontWeight: "bold",
                }}
              >
                {report_rate}%
              </h1>
            </div>

            <Tag
              style={{
                background: "#b5dcf5",
                border: "none",
                borderRadius: 12,
                padding: "10px",
                marginLeft: "auto",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FileExclamationOutlined  style={{ color: "#5B8DEF", fontSize: 18 }} />
            </Tag>
          </Card>
        </Col>

        {/* Reported spam Rate */}
       <Col flex="1">
          <Card
            bordered={false}
            style={{
              width: "100%",
              borderRadius: 16,
              height: 100,
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ marginTop: "-10px" }}>
              <h3 style={{ color: "#6b7280", margin: 0 }}>Spam Rate</h3>
              <h1
                style={{
                  color: "#f97d7d",
                  fontSize: "28px",
                  fontWeight: "bold",
                }}
              >
                {report_spam_rate}%
              </h1>
            </div>

            <Tag
              style={{
                background: "#fad2d1",
                border: "none",
                borderRadius: 12,
                padding: "10px",
                marginLeft: "auto",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FlagOutlined style={{ color: "#f97d7d", fontSize: 18 }} />
            </Tag>
          </Card>
        </Col>
      </Row>

      <Row gutter={[24, 24]} style={{ marginTop: "20px" }}>
        {/* Department Heatmap */}
        <Col xs={24} sm={24} md={12} lg={12}>
          <Card
            hoverable
            style={{
              borderRadius: 16,
              height: 80,
              display: "flex",
              alignItems: "center",
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
            onClick={() => navigate("/department-heatmap")}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  background: "#ede9fe",
                  padding: "10px",
                  borderRadius: "12px",
                  marginLeft: "-60px",
                }}
              >
                <BarChartOutlined style={{ color: "#8c3add", fontSize: 18 }} />
              </div>

              <div>
                <h3 style={{ margin: 0 }}>Department Heatmap</h3>
                <span style={{ color: "gray", fontSize: "13px" }}>
                  View risk by department
                </span>
              </div>
            </div>

            <ArrowRightOutlined
              style={{ color: "gray", fontSize: "18px", marginLeft: "150px" }}
            />
          </Card>
        </Col>

        {/* Human Risk Scorecard */}
        <Col xs={24} sm={24} md={12} lg={12}>
          <Card
            hoverable
            style={{
              borderRadius: 16,
              height: 80,
              display: "flex",
              alignItems: "center",
            }}
            bodyStyle={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "100%",
            }}
            onClick={() => navigate("/human-risk-scorecard")}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{
                  background: "#d1fae5",
                  padding: "10px",
                  borderRadius: "12px",
                  marginLeft: "-60px",
                }}
              >
                <MailOutlined style={{ color: "#1fa7a1", fontSize: 18 }} />
              </div>

              <div>
                <h3 style={{ margin: 0 }}>Human Risk Scorecard</h3>
                <span style={{ color: "gray", fontSize: "13px" }}>
                  Individual risk scores
                </span>
              </div>
            </div>
            <ArrowRightOutlined
              style={{ color: "gray", fontSize: "18px", marginLeft: "150px" }}
            />
          </Card>
        </Col>
      </Row>

      <Card style={{ marginTop: "30px" }}>
        <Row gutter={16}>
          <Col span={20}>
            <h2>Latest Campaign</h2>
          </Col>

          <Col span={4}>
            <Button
              type="primary"
              variant="solid"
              style={{ width: "100%" }}
              size="mideum"
              onClick={() => navigate("/campaign")}
            >
              All Campaign
            </Button>
          </Col>
        </Row>

        {loader ? (
          <>
            <CulsightPageLoader />
          </>
        ) : (
          <>
            <Table
              columns={columns}
              pagination={false}
              dataSource={table_data?.slice(0, 5)}
              style={{ marginTop: "15px" }}
            />
          </>
        )}


      </Card>
    </div>
  );
}

export default Dashboard;

